export var TypeActionBalancing;
(function (TypeActionBalancing) {
    TypeActionBalancing["Registered"] = "Balancing > Registered";
})(TypeActionBalancing || (TypeActionBalancing = {}));
export var actionBalancingRegistered = function () { return ({
    type: TypeActionBalancing.Registered,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/balancing/actionBalancing.ts
// module id = 450
// module chunks = 3